
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipSimplifiedFilled as ObiOwnShipSimplifiedFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-simplified-filled.js';
 
 
 

 
 export const ObiOwnShipSimplifiedFilled = createComponent({
   react: React,
   tagName: 'obi-own-ship-simplified-filled',
   elementClass: ObiOwnShipSimplifiedFilledElement,
   events: {
     
   }
  });
 
 